// Sibling Products Select Dropdown
if (!window.siblingSelectInitialized) {
  window.siblingSelectInitialized = true;

  const initSiblingSelect = function () {
    // Use event delegation for trigger clicks - works for dynamically added elements (e.g., quick-buy)
    document.addEventListener("click", function (e) {
      const trigger = e.target.closest(".wt-product__siblings__select-trigger");
      if (trigger) {
        const isExpanded = trigger.dataset.expanded === "true";
        trigger.dataset.expanded = isExpanded ? "false" : "true";
        return;
      }

      // Close all dropdowns when clicking outside
      if (!e.target.closest(".wt-product__siblings__select-wrapper")) {
        document
          .querySelectorAll(".wt-product__siblings__select-trigger")
          .forEach((t) => {
            t.dataset.expanded = "false";
          });
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        document
          .querySelectorAll(".wt-product__siblings__select-trigger")
          .forEach((trigger) => {
            trigger.dataset.expanded = "false";
          });
      }
    });

    initSiblingSwatchesScroll();
    initCardSiblingSwatchTooltips();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSiblingSelect);
  } else {
    initSiblingSelect();
  }
}

function initSiblingSwatchesScroll() {
  const containers = document.querySelectorAll(
    ".card__sibling-swatches-container"
  );

  containers.forEach((container) => {
    if (container.dataset.siblingScrollInit === "true") return;
    container.dataset.siblingScrollInit = "true";

    const swatchesWrapper = container.querySelector(".card__sibling-swatches");
    const prevBtn = container.querySelector(".card__sibling-arrow--prev");
    const nextBtn = container.querySelector(".card__sibling-arrow--next");

    if (!swatchesWrapper || !prevBtn || !nextBtn) return;

    function checkOverflow() {
      const hasOverflow =
        swatchesWrapper.scrollWidth > swatchesWrapper.clientWidth;
      container.classList.toggle("has-overflow", hasOverflow);
      updateArrowStates();
    }

    function updateArrowStates() {
      const scrollLeft = swatchesWrapper.scrollLeft;
      const maxScroll =
        swatchesWrapper.scrollWidth - swatchesWrapper.clientWidth;

      prevBtn.disabled = scrollLeft >= -1;
      nextBtn.disabled = scrollLeft <= -(maxScroll - 1);

      prevBtn.style.display = prevBtn.disabled ? 'none' : 'flex';
      nextBtn.style.display = nextBtn.disabled ? 'none' : 'flex';
    }

    function getScrollAmount() {
      const swatchSize =
        parseInt(
          getComputedStyle(container).getPropertyValue(
            "--card-sibling-swatch-size"
          )
        ) || 24;
      const gap = 4;
      const itemWidth = swatchSize + gap;
      const containerWidth = swatchesWrapper.clientWidth;

      const visibleCount = Math.floor(containerWidth / itemWidth);

      return Math.max(1, visibleCount) * itemWidth;
    }

    function scrollBy(amount) {
      swatchesWrapper.scrollBy({ left: amount, behavior: "smooth" });
    }

    prevBtn.addEventListener("click", () => scrollBy(getScrollAmount()));
    nextBtn.addEventListener("click", () => scrollBy(-getScrollAmount()));
    swatchesWrapper.addEventListener("scroll", updateArrowStates);

    checkOverflow();

    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(() => {
        checkOverflow();
      });
      resizeObserver.observe(container);
    }
    window.addEventListener("resize", checkOverflow);
  });
}

function initCardSiblingSwatchTooltips() {
  if (window.__cardSiblingTooltipInit === true) return;
  window.__cardSiblingTooltipInit = true;

  const isTouchLike =
    (window.matchMedia && window.matchMedia("(hover: none)").matches) ||
    ("ontouchstart" in window && !(window.matchMedia && window.matchMedia("(hover: hover)").matches));

  const tooltipId = "card-sibling-tooltip";
  let tooltip = document.getElementById(tooltipId);
  if (!tooltip) {
    tooltip = document.createElement("div");
    tooltip.id = tooltipId;
    tooltip.className = "card__sibling-tooltip-float";
    tooltip.setAttribute("role", "tooltip");
    tooltip.setAttribute("aria-hidden", "true");
    document.body.appendChild(tooltip);
  }

  document
    .querySelectorAll(".card__sibling-swatches-container")
    .forEach((container) => {
      container.dataset.floatingTooltips = "true";
    });

  let activeAnchor = null;
  let hideTimer = null;
  let touchClearTimer = null;

  function getAnchorFromEventTarget(target) {
    const anchor = target.closest(".card__sibling-swatch");
    if (!anchor) return null;
    const container = anchor.closest(".card__sibling-swatches-container");
    if (!container) return null;
    if (container.dataset.floatingTooltips !== "true") {
      container.dataset.floatingTooltips = "true";
    }
    return anchor;
  }

  function setTooltipText(anchor) {
    const text =
      anchor.getAttribute("data-tooltip") ||
      anchor.getAttribute("aria-label") ||
      anchor.textContent ||
      "";

    tooltip.textContent = text.trim();
  }

  function positionTooltip(anchor) {
    if (!anchor) return;
    const rect = anchor.getBoundingClientRect();

    tooltip.style.maxWidth = `${Math.min(220, Math.max(120, window.innerWidth - 16))}px`;

    const ttRect = tooltip.getBoundingClientRect();
    const desiredCenterX = rect.left + rect.width / 2;

    const minLeft = 8 + ttRect.width / 2;
    const maxLeft = window.innerWidth - 8 - ttRect.width / 2;
    const left = Math.min(maxLeft, Math.max(minLeft, desiredCenterX));

    let placement = "top";
    let top = rect.top - 8;
    if (top - ttRect.height < 8) {
      placement = "bottom";
      top = rect.bottom + 8;
    }

    tooltip.dataset.placement = placement;
    tooltip.style.left = `${left}px`;
    tooltip.style.top = `${top}px`;

    const maxArrowOffset = Math.max(0, ttRect.width / 2 - 10);
    const arrowOffset = Math.min(
      maxArrowOffset,
      Math.max(-maxArrowOffset, desiredCenterX - left)
    );
    tooltip.style.setProperty(
      "--tooltip-arrow-offset",
      `${arrowOffset}px`
    );
  }

  function show(anchor) {
    if (!anchor) return;
    clearTimeout(hideTimer);
    clearTimeout(touchClearTimer);
    activeAnchor = anchor;

    setTooltipText(anchor);
    tooltip.classList.add("is-visible");
    tooltip.setAttribute("aria-hidden", "false");

    requestAnimationFrame(() => positionTooltip(anchor));
  }

  function hide() {
    activeAnchor = null;
    tooltip.classList.remove("is-visible");
    tooltip.setAttribute("aria-hidden", "true");
  }

  if (!isTouchLike) {
    document.addEventListener("pointerover", (e) => {
      const anchor = getAnchorFromEventTarget(e.target);
      if (!anchor) return;
      show(anchor);
    });

    document.addEventListener("pointerout", (e) => {
      const anchor = getAnchorFromEventTarget(e.target);
      if (!anchor) return;
      const toEl = e.relatedTarget;
      if (toEl && anchor.contains(toEl)) return;
      hideTimer = window.setTimeout(hide, 50);
    });

    // Click a swatch -> re-render the card (image / price / badges) in place
    document.addEventListener("click", (e) => {
      // Let modifier / middle clicks open the sibling page in a new tab as usual
      if (
        e.defaultPrevented ||
        e.button !== 0 ||
        e.metaKey ||
        e.ctrlKey ||
        e.shiftKey ||
        e.altKey
      ) {
        return;
      }
      const anchor = getAnchorFromEventTarget(e.target);
      if (!anchor) return;
      e.preventDefault();
      performSiblingSwap(anchor);
    });
  }

  if (isTouchLike) {
    document.addEventListener(
      "click",
      (e) => {
        const anchor = getAnchorFromEventTarget(e.target);
        if (!anchor) {
          hide();
          return;
        }

        // Single tap: re-render the card in place and briefly show the color name
        e.preventDefault();
        show(anchor);
        clearTimeout(touchClearTimer);
        touchClearTimer = window.setTimeout(hide, 1400);
        performSiblingSwap(anchor);
      },
      true
    );
  }

  document.addEventListener("focusin", (e) => {
    const anchor = getAnchorFromEventTarget(e.target);
    if (!anchor) return;
    show(anchor);
  });

  document.addEventListener("focusout", (e) => {
    const anchor = getAnchorFromEventTarget(e.target);
    if (!anchor) return;
    hideTimer = window.setTimeout(hide, 50);
  });

  document.addEventListener(
    "scroll",
    () => {
      if (!activeAnchor) return;
      if (isTouchLike) {
        hide();
      } else {
        positionTooltip(activeAnchor);
      }
    },
    true
  );

  window.addEventListener("resize", () => {
    if (!activeAnchor) return;
    positionTooltip(activeAnchor);
  });
}

// Fade the new card image in on top of the current one, then commit it underneath
// and remove the overlay — a seamless crossfade with no blank gap or spinner.
// The overlay is added to the DOM *before* its source is set so `sizes` resolves
// against layout only once; start/finish are one-shot so repeated `load` events
// (from srcset re-resolution) can never re-trigger the add/remove cycle.
function crossfadeCardImage(img, picture, newSrc, newSrcset) {
  if (!img || !picture || !newSrc) return;

  const commit = () => {
    img.setAttribute("src", newSrc);
    if (newSrcset) img.setAttribute("srcset", newSrcset);
  };

  const overlay = document.createElement("img");
  overlay.className = "card__sibling-fade-img";
  overlay.alt = "";
  overlay.setAttribute("aria-hidden", "true");
  overlay.style.cssText =
    "position:absolute;inset:0;width:100%;height:100%;object-fit:cover;" +
    "opacity:0;transition:opacity .3s ease;z-index:2;pointer-events:none;" +
    "border-radius:" + getComputedStyle(img).borderRadius + ";";

  picture.appendChild(overlay);
  if (img.sizes) overlay.sizes = img.sizes;

  let finished = false;
  const finish = () => {
    if (finished) return;
    finished = true;
    // Move the new image onto the real element, but only remove the overlay once
    // that image is actually decoded — otherwise the old frame flashes for an
    // instant while the new src hasn't painted yet.
    commit();
    const removeOverlay = () => overlay.remove();
    if (img.decode) {
      img.decode().then(removeOverlay).catch(removeOverlay);
    } else {
      requestAnimationFrame(removeOverlay);
    }
  };

  overlay.onload = () => {
    overlay.onload = null;
    // Force a reflow so the opacity transition reliably runs from 0 -> 1
    void overlay.offsetWidth;
    overlay.style.opacity = "1";
    overlay.addEventListener("transitionend", finish, { once: true });
    window.setTimeout(finish, 450); // safety net if transitionend doesn't fire
  };
  overlay.onerror = () => {
    overlay.onload = null;
    finish();
  };

  if (newSrcset) overlay.srcset = newSrcset;
  overlay.src = newSrc;
}

// Re-render a product card in place when one of its sibling swatches is selected.
// Swaps the image (+ hover image), price and badges, and updates the card links /
// quick-add target — without navigating to the sibling's product page.
// All data is pre-rendered on the swatch (see snippets/card-sibling-swatch.liquid).
function performSiblingSwap(anchor) {
  if (!anchor || anchor.classList.contains("card__sibling-swatch--active")) return;

  const root =
    anchor.closest("color-swatch") || anchor.closest(".card__container");
  if (!root) return;

  const wrapper = anchor.closest(".card__sibling-swatch-wrapper");
  const data = anchor.dataset;

  // --- Main image (smooth crossfade, no spinner) ---
  const img = root.querySelector(".card__img:not(.card__img--hover)");
  if (img && data.siblingImg && img.getAttribute("src") !== data.siblingImg) {
    img.classList.remove("hidden");
    const picture = img.closest(".card__picture") || img.parentElement;
    crossfadeCardImage(img, picture, data.siblingImg, data.siblingSrcset);

    // Hide any product video so the swapped image is visible
    const video = root.querySelector(".card__video");
    if (video) video.classList.add("hidden");
  }

  // --- Hover image ---
  const hoverImg = root.querySelector(".card__img--hover");
  if (hoverImg && data.siblingHoverImg) {
    hoverImg.setAttribute("src", data.siblingHoverImg);
    if (data.siblingHoverSrcset) {
      hoverImg.setAttribute("srcset", data.siblingHoverSrcset);
    }
  }

  // --- Price ---
  const priceEl = root.querySelector(".card__price");
  const priceTmpl =
    wrapper && wrapper.querySelector(".card__sibling-price-template");
  if (priceEl && priceTmpl) priceEl.innerHTML = priceTmpl.innerHTML;

  // --- Badges ---
  const badgesEl = root.querySelector(".card__badges");
  const badgesTmpl =
    wrapper && wrapper.querySelector(".card__sibling-badges-template");
  if (badgesEl && badgesTmpl) badgesEl.innerHTML = badgesTmpl.innerHTML;

  // --- Card links (image + title) and GA4 attributes ---
  if (data.siblingHref) {
    const cardLink = root.querySelector("a.card");
    if (cardLink) {
      cardLink.setAttribute("href", data.siblingHref);
      if (data.siblingVariantId) {
        cardLink.setAttribute("data-ga4-item-id", data.siblingVariantId);
      }
      if (data.siblingPrice) {
        cardLink.setAttribute("data-ga4-item-price", data.siblingPrice);
      }
    }
    const titleLink = root.querySelector(".card__title a");
    if (titleLink) titleLink.setAttribute("href", data.siblingHref);
  }

  const available = data.siblingAvailable !== "false";

  // --- Quick add target ("choose options" — multi-variant products) ---
  const quickAdd = root.querySelector("quick-add");
  if (quickAdd) {
    if (data.siblingHandle) {
      quickAdd.setAttribute("data-product-handle", data.siblingHandle);
    }
    const qaButton = quickAdd.querySelector("button");
    if (qaButton) {
      if (data.siblingHref) qaButton.dataset.productUrl = data.siblingHref;
      qaButton.disabled = !available;
    }
  }

  // --- Direct add-to-cart form (single-variant products) ---
  const productForm = root.querySelector("product-form");
  if (productForm) {
    if (data.siblingVariantId) {
      const idInput = productForm.querySelector("[name=id]");
      if (idInput) idInput.value = data.siblingVariantId;
      productForm.setAttribute("data-ga4-item-id", data.siblingVariantId);
    }
    if (data.siblingPrice) {
      productForm.setAttribute("data-ga4-item-price", data.siblingPrice);
    }

    const submitBtn = productForm.querySelector('button[name="add"]');
    if (submitBtn) {
      submitBtn.disabled = !available;
      const labelSpan = submitBtn.querySelector("span");
      const swContainer = root.querySelector(".card__sibling-swatches-container");
      if (labelSpan && swContainer) {
        const label = available
          ? swContainer.dataset.siblingAddLabel
          : swContainer.dataset.siblingSoldoutLabel;
        if (label) labelSpan.textContent = label;
      }
    }
  }

  // --- Active state ---
  root.querySelectorAll(".card__sibling-swatch").forEach((s) => {
    s.classList.remove("card__sibling-swatch--active");
    s.removeAttribute("aria-current");
  });
  anchor.classList.add("card__sibling-swatch--active");
  anchor.setAttribute("aria-current", "true");
}
